import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { Title, useRedirect } from 'react-admin';
import { useLocation } from 'react-router-dom';
import { CustomTabs } from '../../common/CustomTabs/CustomTabs';
import { PageHeader } from '../../common/PageHeader/PageHeader';
import { TabPanel } from '../../common/TabPanel/TabPanel';
import '../../common/tab-section.css';
import DocumentTypesSetting from './DocumentType/DocumentTypesSetting';
import LlmPromptsList from './LlmPrompt/LlmPromptsList';

const DocumentSettings: React.FC = () => {
  const location = useLocation();
  const redirect = useRedirect();
  const [configTabIndex, setConfigTabIndex] = useState(0);

  // Read initial tab from query params
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get('tab');

    if (tabParam === 'llm-prompts') {
      setConfigTabIndex(1);
    } else {
      setConfigTabIndex(0);
    }
  }, [location.search]);

  const handleConfigTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setConfigTabIndex(newValue);

    const searchParams = new URLSearchParams(location.search);
    if (newValue === 1) {
      searchParams.set('tab', 'llm-prompts');
    } else {
      searchParams.delete('tab');
    }

    redirect(`${location.pathname}?${searchParams.toString()}`);
  };

  return (
    <Box mt={4} className='tab-section-table'>
      <Title title='Document Settings' />

      <CustomTabs
        tabLabels={[
          { label: 'Document Types', onClick: () => {} },
          { label: 'LLM Prompts', onClick: () => {} },
        ]}
        value={configTabIndex}
        onChange={handleConfigTabChange}
      />

      <TabPanel value={configTabIndex} index={0} sx={{ padding: '14px 0' }}>
        <Box className='tab-section'>
          <PageHeader
            breadcrumbs={[
              { label: 'Documents', onClick: () => redirect('/documents/library') },
              { label: 'Settings', active: true },
            ]}
          />
          <DocumentTypesSetting />
        </Box>
      </TabPanel>

      <TabPanel value={configTabIndex} index={1} sx={{ padding: '14px 0' }}>
        <Box className='tab-section'>
          <PageHeader
            breadcrumbs={[
              { label: 'Documents', onClick: () => redirect('/documents/library') },
              { label: 'Settings', active: true },
            ]}
          />
          <LlmPromptsList />
        </Box>
      </TabPanel>
    </Box>
  );
};

export default DocumentSettings;
